<script setup lang="ts">
import PartnerRakutenTemplate from '~/components/templates/_lp/PartnerRakutenTemplate/PartnerRakutenTemplate.vue';

useAppMeta({
  title: '楽天証券 - 楽天証券認定のIFAと無料チャット',
  hasTitleSuffix: false,
  description:
    'スマホで簡単にお金の健康診断。楽天証券認定のIFA（独立系ファイナンシャルアドバイザー）が失敗しない運用について無料でアドバイス。自宅からチャットで気軽に相談できます。',
});
definePageMeta({
  layout: 'plain',
});
</script>

<template>
  <PartnerRakutenTemplate />
</template>
